import { ClickAndCollect } from '@/components/ClickAndCollect';
import { DeliveryAddress } from '@/components/DeliveryAddress';
import { DeliveryMethod } from '@/components/DeliveryMethod';
import { DeliveryOptionsToggle } from '@/components/DeliveryOptionsToggle';
import { useCheckout } from '@/contexts/checkoutContext';
import { useShipping } from '@/contexts/shippingContext';

export const DeliveryDetails = () => {
  const { checkoutData } = useCheckout();
  const { isClickAndCollectAvailable } = checkoutData;

  const { isClickAndCollect, isDelivery } = useShipping();

  return (
    <>
      {isClickAndCollectAvailable ? <DeliveryOptionsToggle /> : null}
      {isClickAndCollect ? <ClickAndCollect /> : null}
      {isDelivery ? (
        <>
          <DeliveryAddress />
          <DeliveryMethod />
        </>
      ) : null}
    </>
  );
};
